
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";

export const useDeleteAccount = (loadAccountsCallback: () => Promise<void>) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { toast } = useToast();

  const deleteAccount = async (id: string) => {
    setIsDeleting(true);
    try {
      const { error } = await supabase
        .from('account')
        .delete()
        .eq('id', id);

      if (error) throw error;

      await loadAccountsCallback();
      toast({
        title: "Success",
        description: "Account deleted successfully",
      });
    } catch (error) {
      console.error('Error deleting account:', error);
      toast({
        title: "Error",
        description: "Failed to delete account",
        variant: "destructive",
      });
      throw error;
    } finally {
      setIsDeleting(false);
    }
  };

  return { deleteAccount, isDeleting };
};
